import { sendGet } from "./generic"

export const getStates = () => {
    return sendGet(`Enums/State`)
}

export const getTypeOfEntity = () => {
    return sendGet(`Enums/TypeOfEntity`)
}

export const getRoles = () => {
    return sendGet(`Enums/Role`)
}

export const getNamedInsuredRelationships = () => {
    return sendGet(`Enums/NamedInsuredRelationship`)
}

export const getRetentionAmount = () => {
    return sendGet(`Enums/Retention`)
}

export const getContractorsPollutionCoverage = () => {
    return sendGet(`Enums/ContractorsPollutionCoverage`)
}

export const getProfessionalLiabilityCoverage = () => {
    return sendGet(`Enums/ProfessionalLiabilityCoverage`)
}

export const getNonOwnedDisposalSiteCoverages = () => {
    return sendGet(`Enums/NonOwnedDisposalSiteCoverage`)
}

export const getMoldCoverages = () => {
    return sendGet(`Enums/MoldCoverage`)
}

export const getLimits = () => {
    return sendGet(`Enums/Limits`)
}

export const getApplicationStatus = () => {
    return sendGet(`Enums/ApplicationStatus`)
}

export const getEndorsementTypes = () => {
    return sendGet(`Enums/EndorsementType`)
}

export const getLogicalOperatorTypes = () => {
    return sendGet(`Enums/LogicalOperatorType`)
}

export const getEndorsementAppliesToList = () => {
    return sendGet(`Enums/EndorsementAppliesTo`)
}
